// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ecabbe65","878":"7dd3a1ae"}[chunkId] + ".chunk.js";
};